import {
  createSlice,
} from '@reduxjs/toolkit';
import setEntitiesState, { setBaseState } from '../../../../../store/utils/setStoreState.js';

const paymentMethodsSlice = createSlice({
  name: 'paymentMethods',
  initialState: {
    entities: {
      paymentMethods: {},
    },
    currentActivePaymentMethod: '',
    isRenderPaymentMethods: false,
    isSupportAVS: false, // will set it in integrate component like in makePayment, makeMultiPayment and cof widget
    billingContactConfig: null, // will set it in integrate component like in checkout widget
    billingContact: undefined,
    supportTypes: [],
    latestBillingContact: undefined, // use for keep billing section data
  },
  reducers: {
    setPaymentMethods: setEntitiesState('paymentMethods'),
    setCurrentActivePaymentMethod: setBaseState('currentActivePaymentMethod'),
    setIsRenderPaymentMethods: setBaseState('isRenderPaymentMethods'),
    setIsSupportAVS: setBaseState('isSupportAVS'),
    setBillingContact: setBaseState('billingContact'),
    setBillingContactConfig: setBaseState('billingContactConfig'),
    setSupportTypes: setBaseState('supportTypes'),
    setLatestBillingContact: setBaseState('latestBillingContact'),
  },
});

export const {
  setPaymentMethods,
  setCurrentActivePaymentMethod,
  setIsRenderPaymentMethods,
  setIsSupportAVS,
  setBillingContact,
  setBillingContactConfig,
  setSupportTypes,
  setLatestBillingContact,
} = paymentMethodsSlice.actions;

export default paymentMethodsSlice.reducer;
